import { Pipe, PipeTransform } from "@angular/core";
import { District } from "../../core/models/district.model";

@Pipe({
    name: 'filterByStateId'
})
export class StateIdPipe implements PipeTransform {

    transform(districts: District[] = [], state_id: number): District[] {

        return districts.filter(item => {

            if (item.state_id == state_id) {
                return true;
            }

            return false;
        });
    }

}


// WEBPACK FOOTER //
// /home/forge/dev-client-app.instaveritas.com/releases/20231127121751/src/app/common/pipes/state-id.pipe.ts